/* eslint-disable sonarjs/no-duplicate-string */

'use strict';

const modelBody = '.product-quickview-body';
const $modalBackground = $('.modal-background');
const $quickViewModal = $('.product-quickview-modal');
const mainContainerSelector = '.container.search-results';
const ariaHidden = 'aria-hidden';
const tabPane = '.tab-pane.active';
const ariaExpanded = 'aria-expanded';

// Focus trap state
var previousActiveElement = null;
var focusTrapEnabled = false;
// Selector for focusable elements
var focusableSelector = [
    'a[href]', 'area[href]', 'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])',
    'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex="-1"])'
].join(',');

/**
 * Get visible focusable elements inside a container.
 * @param {Element} container DOM element to search
 * @returns {Element[]} list of focusable elements
 */
function getFocusableElements(container) {
    return Array.prototype.slice.call(container.querySelectorAll(focusableSelector))
        .filter(function (el) {
            return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
        });
}

/**
 * Focus the first focusable element inside the modal, or the modal itself as fallback.
 */
function focusFirstFocusable() {
    var modalEl = document.getElementById('QuickView_Drawer');
    if (!modalEl) return;
    var focusable = getFocusableElements(modalEl);
    if (focusable.length) {
        focusable[0].focus();
    } else {
        modalEl.focus();
    }
}

/**
 * Keydown handler to trap Tab and close modal on Escape.
 * @param {KeyboardEvent} e keydown event
 */
function trapKeydown(e) {
    var modalEl = document.getElementById('QuickView_Drawer');
    if (!modalEl) return;
    if (modalEl.classList.contains('hidden')) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
        // close the modal on Escape by clicking the close button
        var closeBtn = document.querySelector('.product-quickview-modal button.close');
        if (closeBtn) { closeBtn.click(); }
        return;
    }

    if (e.key !== 'Tab') return;

    var focusable = getFocusableElements(modalEl);
    if (focusable.length === 0) {
        e.preventDefault();
        return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;

    if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
    } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
    }
}

/**
 * Enable the focus trap; store previously focused element for restoration.
 */
function enableFocusTrap() {
    if (focusTrapEnabled) return;
    focusTrapEnabled = true;
    previousActiveElement = document.activeElement;
    document.addEventListener('keydown', trapKeydown);
}

/**
 * Disable the focus trap and restore focus to the opener if available.
 */
function disableFocusTrap() {
    if (!focusTrapEnabled) return;
    focusTrapEnabled = false;
    document.removeEventListener('keydown', trapKeydown);
    if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        try { previousActiveElement.focus(); } catch (e) { /* ignore */ }
    }
    previousActiveElement = null;
}

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $.spinner().start();
    $(modelBody).empty();
    document.body.classList.add('nb-modal-display');
    $modalBackground.css('display', 'block');
    // This is required for desktop quick view: mark siblings hidden to AT
    $quickViewModal.siblings().attr(ariaHidden, true);
    $quickViewModal.closest('.row').siblings().attr(ariaHidden, true);
    $quickViewModal.closest(tabPane).siblings().attr(ariaHidden, true);
    $quickViewModal.closest(mainContainerSelector).siblings().attr(ariaHidden, true);
    // This is required for desktop quick view
    $quickViewModal.toggleClass('hidden');
    $quickViewModal.find('button.close').attr(ariaExpanded, true);
    // enable focus trap now; content may be loaded async and we'll focus first focusable after load
    enableFocusTrap();
    // This makes the modal go off the screen on mobile
    if ($quickViewModal.attr('style')) {
        $quickViewModal.removeAttr('style');
    }
    // This only applies to mobile view
    $quickViewModal.css({ '-webkit-transform': 'translateY(16%)' });
    $('.product-quickview-modal button.close').focus();

    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            $(modelBody).html(parsedHtml.body);
            $modalBackground.css('display', 'block');
            $.spinner().stop();
            $('.product-quickview-modal #pdpCarousel video').trigger('play');
            $('.product-quickview-modal #pdpCarousel').carousel('cycle');
            // After content loads, ensure first focusable inside modal gets focus
            setTimeout(focusFirstFocusable, 10);
        },
        error: function (error) {
            window.console.error('Error loading quickview content: ', error);
            $.spinner().stop();
        }
    });
}

/**
 * Handle QuickView click event when clicking the close button
 */
function closeQuickViewModal() {
    $modalBackground.css('display', 'none');
    $quickViewModal.css({ '-webkit-transform': 'translateY(100%)' });
    $quickViewModal.siblings().attr(ariaHidden, false);
    $quickViewModal.closest('.row').siblings().attr(ariaHidden, false);
    $quickViewModal.find('button.close').attr(ariaExpanded, false);
    $quickViewModal.closest(tabPane).siblings().attr(ariaHidden, false);
    $quickViewModal.closest(mainContainerSelector).siblings().attr(ariaHidden, false);
    document.body.classList.remove('nb-modal-display');
    // This is required for desktop quick view
    $quickViewModal.toggleClass('hidden');
    // This makes the modal go off the screen on mobile
    if ($quickViewModal.attr('style')) {
        $quickViewModal.removeAttr('style');
    }
    // disable trap and restore focus
    disableFocusTrap();
}

$('body').on('show.bs.modal', '#zoommodal', function (e) {
    if ($('.product-quickview-modal').length) {
        return e.preventDefault();
    }
    return undefined;
});

module.exports = {
    showQuickview: function () {
        $(document).ready(function () {
            $('body').on('click', '.js-quickview', function (e) {
                e.preventDefault();
                var selectedValueUrl = $(this).data('url');
                var selectedStyle = $(this).closest('.product').attr('data-selected-style') || $(this).data('style');
                var pid = $(this).closest('.product').attr('data-pid');
                if (selectedStyle.length > 0 && pid.length > 0) {
                    selectedValueUrl += `&dwvar_${pid}_style=` + selectedStyle;
                }
                $(e.target).trigger('quickview:show');
                fillModalElement(selectedValueUrl);
            });
        });
    },
    closeQuickview: function () {
        // QuickView close button
        $(document).on('click', '.product-quickview-modal button.close', function (e) {
            e.stopPropagation();
            closeQuickViewModal();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            var quickViewCtn = response.container;
            if ($('.product-quickview').length > 0) {
                quickViewCtn.attr('data-pid', response.data.product.id);
                quickViewCtn.find('.product-id').text(response.data.product.id);
                $('.full-pdp-link').attr('href', response.data.product.selectedProductUrl);
            }

            if ((response.data.preOrderData && response.data.preOrderData.hasPreOrder) || (response.data.backOrderData && response.data.backOrderData.hasBackOrder)) {
                quickViewCtn.find('button.add-to-cart').prop('disabled', true);
                quickViewCtn.find('.preorder-qty-msg').removeClass('d-none');
            }
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            closeQuickViewModal();
        });
    }
};
